import type { ReactNode } from 'react';
import { Flex } from '@radix-ui/themes';

export function Page({ children }: { children: ReactNode }) {
  return (
    <Flex direction="column" gap="5">
      {children}
    </Flex>
  );
}
